const langDocumentNotification = {
	management_report: {
		tag: 'document.notification_sub.management_report',
		fr: 'Rapport de gestion annuels et trimestriels',
		en: 'Quarterly and annual management report',
	},
	auditor_report: {
		tag: 'document.notification.auditor_report',
		fr: 'Rapport CAC',
		en: 'Auditor report',
	},
	nav_sheet: {
		tag: 'document.notification.nav_sheet',
		fr: 'Fiche VL',
		en: 'NAV sheet',
	},
	ampere_report: {
		tag: 'document.notification.ampere_report',
		fr: 'Rapport AMPERE',
		en: 'AMPERE Report',
	},
	esg_reports: {
		tag: 'document.notification.esg_reports',
		fr: 'Rapports ESG',
		en: 'ESG reports',
	},
};

export default langDocumentNotification;
